// App MY MEALS — recettes, menus et courses de la suite MoP.
// v0.4 : incrément 1 (PC3) — Ingrédients (référentiel), Recettes
// (bibliothèque), Repas (compositions recette(s)+extras), Courses. Le
// Planning des menus (grille jour × moment) a déménagé dans My Calendar
// (hub Famille, tuile Repas) — c'est là que vit la notion de planning
// hebdo appliqué au calendrier ; le code reste dans @mop/feature-meals
// (EcranMenus), importé par My Calendar.
import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import {
  CoreProviders, CoquilleApp, EcranFT, EcranProfil,
  useAuth, useT, useMenuOngletActif, FonctionsProvider, FONCTIONS_CORE,
} from '@mop/core';
import { EcranRecettes, EcranRepas, EcranIngredients, EcranCourses, FONCTIONS_REPAS } from '@mop/feature-meals';

const APP = { id: 'mop-my-meals', nom: 'My Meals', version: '0.6.0.12', scheme: 'mopmymeals' };

// L'app COMPOSE les catalogues : socle Core + fonctions du module repas
// (c'est ce catalogue que MoP Admin rattache aux forfaits).
const CATALOGUE = [...FONCTIONS_CORE, ...FONCTIONS_REPAS];

const Profil = () => {
  const { estIVV } = useAuth();
  const t = useT();
  useMenuOngletActif('Profil', [
    { label: t('ft.ivvFaitsTechniques'), icone: '🐞', navigateVers: 'IVV' },
  ], estIVV);
  return <EcranProfil sections={[]} />;
};

const Racine = () => {
  const t = useT();
  const onglets = [
    { cle: 'Ingredients', label: t('ingredients.titre'), icone: '🥕', composant: EcranIngredients },
    { cle: 'Recettes',    label: t('repas.recettes'),     icone: '🍽️', composant: EcranRecettes },
    { cle: 'Repas',       label: t('repas.titre'),        icone: '🍲', composant: EcranRepas },
    { cle: 'Courses',     label: t('courses.titre'),      icone: '🛒', composant: EcranCourses },
    { cle: 'Profil',      label: t('nav.profil'),         icone: '👤', composant: Profil },
    { cle: 'IVV',         label: t('nav.ivv'),            icone: '🐞', composant: EcranFT, masque: true },
  ];
  return <CoquilleApp onglets={onglets} avecPub />;
};

export default function App() {
  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <CoreProviders app={APP} theme="auto">
        <FonctionsProvider catalogue={CATALOGUE}>
          <StatusBar style="auto" />
          <Racine />
        </FonctionsProvider>
      </CoreProviders>
    </GestureHandlerRootView>
  );
}
